import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RefreshTabsService {

  constructor() {
    // Listen for storage events
    window.addEventListener('storage', (event) => {
      // Check if the 'refresh' key was set and matches the specific origin
      if (event.key === 'refresh' && event.newValue === 'true') {
        if (window.location.origin === 'http://localhost:4200') {
          localStorage.removeItem('refresh'); // Clean up after refresh
          window.location.reload();
        }
      }
    });
  }

  // Trigger refresh on all tabs of the same origin
  refreshSpecificTabs() {
    localStorage.setItem('refresh', 'true');
  }
}